import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ui-company-block',
  templateUrl: './company-block.component.html',
  styleUrls: ['./company-block.component.scss']
})
export class CompanyBlockComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./client/app/shared/blocks/company-block/company-block.component.ts